import Vue from 'vue';

const getClient = () => Vue.api.getClient('news');

export const STATUS = {
  LOADING: 'news.status.loading',
  SUCCESS: 'news.status.success',
  CANCELLED: 'news.status.cancelled',
  ERROR: 'news.status.error',
};

const initialState = {
  news: [],
  welcomeNews: [],
  detail: [],
  status: '',
  error: null,
  detailRequest: null,
};

const mutations = {
  setNews(state, news) {
    state.news = news;
  },
  setWelcomeNews(state, welcomeNews) {
    state.welcomeNews = welcomeNews;
  },
  setStatus(state, status) {
    state.status = status;
  },
  setError(state, error) {
    state.error = error;
  },
  setNewsItem(state, { id, item }) {
    const newsItem = state.news.find((n) => n.id === id);
    newsItem.resolution = item.resolution;
    if (!state.detail.includes(id)) {
      state.detail.push(id);
    }
  },
  setDetailRequest(state, req) {
    state.detailRequest = req;
  },
  reset(state) {
    Object.keys(state)
      .forEach((key) => {
        state[key] = initialState[key];
      });
  },
};

const actions = {
  async load({ commit, rootState }, id) {
    try {
      const { user } = rootState.session.session;
      commit('setStatus', STATUS.LOADING);
      const welcomeNews = await getClient().getCgesNews({
        apiCges: {
          delegado: user.userid,
        },
      });
      commit('setWelcomeNews', welcomeNews || []);
      const news = await getClient().list(0, 5, {
        primaryIndex: id,
        status: '(70, 80)',
      }, 'CREATION_DATE DESC');
      const orderedNews = news.list.sort((a, b) => new Date(b.creationDate) - new Date(a.creationDate)); // eslint-disable-line
      commit('setNews', orderedNews || []);
      commit('setStatus', STATUS.SUCCESS);
    } catch (ex) {
      commit('setError', ex);
      commit('setStatus', STATUS.ERROR);
      commit('setNews', []);
    }
  },
  async detail({ commit }, id) {
    let req;
    try {
      commit('setStatus', STATUS.LOADING);
      req = getClient().get(id);
      commit('setDetailRequest', req);
      const response = await req;
      commit('setStatus', STATUS.SUCCESS);
      commit('setDetailRequest', null);
      commit('setNewsItem', {
        id,
        item: req.format(response).unique(),
      });
    } catch (ex) {
      console.error('error querying detail (canceled = ', req.cancelled, ')', ex);
      if (!req.cancelled) {
        commit('setError', ex);
        commit('setStatus', STATUS.ERROR);
        commit('setDetailRequest', null);
      }
    }
  },
  cancel({ commit, state }) {
    if (state.detailRequest != null && state.status === STATUS.LOADING) {
      state.detailRequest.cancel();
      commit('setDetailRequest', null);
      commit('setStatus', STATUS.CANCELLED);
    }
  },
  reset({ commit }) {
    console.log('news reset action received');
    commit('reset');
  },
};

const getters = {
  list: (state) => state.news || [],
  welcomeNews: (state) => state.welcomeNews || [],
  hasDetail: (state) => (id) => state.detail.some(($id) => $id === id),
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
};
